"use client";
import Balancer from "react-wrap-balancer";
import { useEffect, useState } from "react";

export default function ContactPage({ translations }: { translations: any }) {
  const defaultUrl = "https://legal.createporn.com/Create%20Porn%20-%20Contact%20-%20en-US.pdf";
  const langUrl = `https://legal.createporn.com/Create%20Porn%20-%20Contact%20-%20${translations.key}.pdf`;
  const [url, setUrl] = useState(langUrl);

  //check if the PDF for the language exists, otherwise default to english
  const checkPdfExists = async (pdf: string) => {
    try {
      const response = await fetch(pdf, { method: "HEAD" });
      if (response.ok) {
        setUrl(pdf);
      } else {
        setUrl(defaultUrl);
      }
    } catch {
      setUrl(defaultUrl);
    }
  };

  useEffect(() => {
    checkPdfExists(langUrl);
  }, []);

  return (
    <>
      <div>
        <div className="mb-6 w-full px-5 md:mb-10 xl:px-0">
          <h1
            className="animate-fade-up bg-gradient-to-br from-[#DD0772] to-white bg-clip-text text-center font-display text-4xl font-bold tracking-[-0.02em] text-transparent opacity-0 drop-shadow-sm md:text-7xl md:leading-[5rem]"
            style={{ animationDelay: "0.15s", animationFillMode: "forwards" }}
          >
            <Balancer>{translations.SEOTitle.slice(0, -2)}</Balancer>
          </h1>
        </div>
        <div className="relative mb-auto flex w-full max-w-6xl flex-col py-5 sm:px-4">
          <div className="flex h-[60vh] items-center justify-center md:h-screen">
            <iframe src={url} className="h-full w-full rounded md:w-[54vw]" />
          </div>
        </div>
      </div>
    </>
  );
}
